import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { PrimaryButton, TertiaryButton } from '@xingternal/malt-button';
import { config } from '@xingternal/hops';

import EditProfileImage from './../../../Components/Illustrations/EditProfileImage';
import PageviewTracker from './../../../Components/PageviewTracker/PageviewTracker';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import parseQueryString from '../../../utils/parseQueryString';
import snakecaseKeys from '../../../utils/snakecaseKeys';
import api from '../../../utils/api';

import styles from './styles.css';
import messages from './messages';

const BouncedEmailInfo = ({ toLogin, location: { search }, email }) => {
  const [isCtaLoading, setIsCtaLoading] = useState(false);
  const [isSkipLoading, setIsSkipLoading] = useState(false);

  const handleCtaClick = e => {
    e.preventDefault();
    setIsCtaLoading(true);

    const queryObject = snakecaseKeys({
      ...parseQueryString(search),
      destUrl: `${config.externalUrl}/settings/account/credentials/email`,
    });

    api
      .post('/login/acknowledge_post_login', queryObject)
      .then(({ target }) => {
        if (target) {
          window.location = target;
        } else {
          toLogin();
        }
      })
      .catch(err => {
        console.error(err);

        setIsCtaLoading(false);
        toLogin();
      });
  };

  const handleSkipClick = e => {
    e.preventDefault();
    setIsSkipLoading(true);

    const queryObject = snakecaseKeys({
      ...parseQueryString(search),
      resolveAction: 'unbounce',
    });

    api
      .post('/login/acknowledge_post_login', queryObject)
      .then(({ target }) => {
        if (target) {
          window.location = target;
        } else {
          toLogin();
        }
      })
      .catch(err => {
        console.error(err);

        setIsSkipLoading(false);
        toLogin();
      });
  };

  return (
    <React.Fragment>
      <PageviewTracker pageName={'wbm/Welcome/login/account/email_bounced'} />
      <EditProfileImage />
      <CustomH>
        <FormattedMessage {...messages.emailBouncedTitle} />
      </CustomH>
      <CustomP>
        <FormattedMessage
          {...messages.emailBouncedParagraph}
          values={{ email }}
        />
      </CustomP>
      <div className={styles.buttonContainer}>
        <TertiaryButton
          className={styles.containerButton}
          loading={isSkipLoading}
          onClick={handleSkipClick}
        >
          <FormattedMessage {...messages.emailBouncedSkipButtonText} />
        </TertiaryButton>
        <PrimaryButton
          className={styles.containerButton}
          loading={isCtaLoading}
          onClick={handleCtaClick}
        >
          <FormattedMessage {...messages.emailBouncedButtonText} />
        </PrimaryButton>
      </div>
    </React.Fragment>
  );
};

export default withRouter(BouncedEmailInfo);
